'use strict';

(function () {
  'use strict';

  angular.module('msOnboarding').factory('authenticationSvc', authenticationSvc);

  authenticationSvc.$inject = ['$window', '$http', '$q', '$sessionStorage', 'msAuth', 'onboardingRouter', 'providerSvc', 'domainSvc', 'userSvc', 'NotifyingSvc', 'languageSvc'];

  function authenticationSvc($window, $http, $q, $sessionStorage, msAuth, onboardingRouter, providerSvc, domainSvc, userSvc, NotifyingSvc, languageSvc) {

    return {
      loadSsoAuthInfo: _loadSsoAuthInfo,
      loadTeladocSsoAuthInfo: _loadTeladocSsoAuthInfo,
      getCurrentSsoInfo: _getCurrentSsoInfo,
      setCurrentSsoInfo: _setCurrentSsoInfo,
      getOrganizationBySsoIdp: _getOrganizationBySsoIdp,
      getAccessCodeBySsoIdp: _getAccessCodeBySsoIdp,
      getFullyQualifiedRedirectUrl: domainSvc.getFullyQualifiedRedirectUrl,
      getDashboardUrl: domainSvc.getUserDashboardDomain,
      submitEmailVerificationRequest: _submitEmailVerificationRequest,
      ssoLogin: _ssoLogin,
      ssoMapAndLogin: _ssoMapAndLogin,
      memberEmailCheck: _memberEmailCheck,
      login: _login,
      reauth: _reauth,
      onLoginSuccess: _onLoginSuccess,
      signup: _signup,
      requestPasswordResetEmail: requestPasswordResetEmail,
      resetPassword: resetPassword,
      verifyLoggedInUserResponse: _handleAuthSuccess,
      loadKeycloakSsoAuthInfo: _loadKeycloakSsoAuthInfo
    };

    function _loadSsoAuthInfo(token, agent, isTest) {
      if (isTest) {
        _createTestUser();
      }
      var deferred = $q.defer();
      var ssoAuthView = $sessionStorage.ssoAuthView;
      // reuse existing loaded ssoAuthView for duration of the sso login experience if possible
      if (ssoAuthView && ssoAuthView.attributesView && ssoAuthView.tokenPairView) {
        deferred.resolve(ssoAuthView);
        return deferred.promise;
      }
      return msAuth.loadSsoAuthInfo(token, agent);
    }

    function _loadTeladocSsoAuthInfo(id, isTest) {
      if (isTest) {
        _createTestUser();
      }
      var deferred = $q.defer();
      var ssoAuthView = $sessionStorage.ssoAuthView;
      // reuse existing loaded ssoAuthView for duration of the sso login experience if possible
      if (ssoAuthView && ssoAuthView.attributesView) {
        deferred.resolve(ssoAuthView);
        return deferred.promise;
      }
      return msAuth.loadTeladocSsoAuthInfo(id);
    }

    function _loadKeycloakSsoAuthInfo(id, isTest) {
      if (isTest) {
        _createTestUser();
      }
      var deferred = $q.defer();
      var ssoAuthView = $sessionStorage.ssoAuthView;
      // reuse existing loaded ssoAuthView for duration of the sso login experience if possible
      if (ssoAuthView && ssoAuthView.attributesView) {
        deferred.resolve(ssoAuthView);
        return deferred.promise;
      }
      return msAuth.loadKeycloakSsoAuthInfo(id);
    }

    function _createTestUser() {
      var suffix = Math.floor(Math.random() * 300);
      $sessionStorage.ssoAuthView = {
        tokenPairView: {
          token: 'test',
          agentId: 'test'
        },
        attributesView: {
          subject: '12345',
          firstName: 'ATestUser',
          emailAddress: 'mynewtest' + suffix + '@test.mystrength.com',
          accessCode: '1149',
          idpId: 'anthem-brand-qa',
          dateOfBirth: '2001-01-01',
          gender: 'MALE',
          memberId: 'AMemberIDwithSTUFF_' + suffix,
          uniqueId: '',
          wellnessCategory: null,
          wellnessProgram: null
        },
        ssoUserMetadata: {
          hasAcceptedTerms: false,
          userAttributeError: null
        }
      };
    }

    function _getCurrentSsoInfo() {
      return $sessionStorage.ssoAuthView;
    }

    function _setCurrentSsoInfo(updatedSsoAuthView) {
      $sessionStorage.ssoAuthView = updatedSsoAuthView;
    }

    function _getAccessCodeBySsoIdp(idpId, accessCode) {
      return $http.get('/apiproxy/public/sso/idps/' + idpId + '/accesscodes/' + accessCode);
    }

    function _getOrganizationBySsoIdp(idpId, accessCode) {
      return $http.get('/apiproxy/public/sso/idps/' + idpId + '/accesscodes/' + accessCode + '/organization');
    }

    function _submitEmailVerificationRequest(ssoAuthView) {
      return msAuth.submitEmailVerificationRequest(ssoAuthView);
    }

    function _ssoMapAndLogin(ssoIdView) {
      return msAuth.ssoMapAndLogin(ssoIdView).then(_onLoginSuccess);
    }

    function _ssoLogin(ssoAuthView) {
      return msAuth.ssoLogin(ssoAuthView).then(function (response) {
        var redirectUrl = response.headers('x-redirect-url');
        // If has patientId follow response x-redirect-url immediately
        if (redirectUrl && ssoAuthView.attributesView && Number.isInteger(parseInt(ssoAuthView.attributesView.patientId))) {
          $window.location = domainSvc.getFullyQualifiedRedirectUrl(redirectUrl);
        }
        return _onLoginSuccess(response);
      });
    }

    function _memberEmailCheck(emailAddress) {
      return $http.post('/apiproxy/public/users/member-version', {
        emailAddress: emailAddress
      });
    }

    function _login(user, timezone) {
      return msAuth.login(user, timezone).then(_onLoginSuccess);
    }

    function _reauth(timezone) {
      return msAuth.reauth(timezone).then(_onReauthSuccess);
    }

    function _signup(user, userMeta, customFields, timezone) {
      return msAuth.signup(user, userMeta, customFields, timezone).then(_onSignUpSuccess);
    }

    function _onLoginSuccess(response) {
      return _handleAuthSuccess(response, NotifyingSvc.EVENTS.USER_LOGIN_COMPLETE);
    }

    function _onSignUpSuccess(response) {
      return _handleAuthSuccess(response, NotifyingSvc.EVENTS.USER_SIGNUP_COMPLETE);
    }

    function _onReauthSuccess(response) {
      return _handleAuthSuccess(response, NotifyingSvc.EVENTS.USER_REAUTH_COMPLETE);
    }

    function _handleAuthSuccess(response, evt) {
      if (response.error) {
        onboardingRouter.navigateError(response.error);
        throw new Error(response.error.message);
      } else {
        var authResponse = response.data;
        // If login returns pwExpired skip ahead to pw change redirect
        if (authResponse.pwExpired) {
          return response;
        }
        if (authResponse && authResponse.response) {
          _processAuthenticatedUser(authResponse);
          NotifyingSvc.notifyEvent(evt, {
            user: $sessionStorage.user
          });
        }
        return response;
      }
    }

    function _processAuthenticatedUser(authResponse) {
      if (!$sessionStorage.authRequirements) {
        $sessionStorage.authRequirements = authResponse.requirements;
      } else {
        $sessionStorage.authRequirements = _.unionWith($sessionStorage.authRequirements, authResponse.requirements, function (o, n) {
          return o.requirementType === n.requirementType;
        });
      }
      $sessionStorage.user = authResponse.response;
      _setProvider($sessionStorage.user);
      if (providerSvc.hasAgreedToCustomTermsOfUse()) {
        //in the case of Humana users, we need to immediately save a File
        //denoting if they've seen and acknowledged the Humana Terms of Use
        _saveTermsOfUseAcceptance($sessionStorage.user);
      }
      if (!_.isEmpty(authResponse.response.language)) {
        languageSvc.setLanguage(authResponse.response.language);
      }
    }

    function _saveTermsOfUseAcceptance(user) {
      //in the case of Humana users, we need to immediately save a File
      //denoting if they've seen and acknowledged the Humana Terms of Use
      var userPreferences = angular.extend({
        agreedToOrganizationTermsAndConditions: true
      }, user.userPreferences);
      userSvc.savePreferences(userPreferences);
    }

    function _setProvider(user) {
      var organization, accessCode, group;
      organization = user.organization.shortName;
      accessCode = user.accessCode.accessCode;
      if (user.accessCodeGroup) {
        group = user.accessCodeGroup.shortName;
      }
      providerSvc.setProvider({
        organization: organization,
        accessCode: accessCode,
        group: group,
        preferences: user.providerPreferences
      });
    }

    function requestPasswordResetEmail(emailAddress) {
      return $http.post('/apiproxy/public/user/password/reset/request', emailAddress);
    }

    function resetPassword(newPassword) {
      return $http.post('/apiproxy/public/user/password/reset', newPassword, { withCredentials: true });
    }
  }
})();